import {
  filterStaticImageAssetsForIds,
  getStaticAssetPath,
  type StaticImageAsset
} from "@/utils/static-assets";
import { Brand } from "@/types";

function getAnimationImageAssetsSupportedByApp(brand: Brand): StaticImageAsset[] {
  if (![Brand.Audi, Brand.Cupra, Brand.Volkswagen, Brand.Lamborghini].includes(brand)) {
    return [];
  }

  if (brand === Brand.Lamborghini) {
    return [
      {
        id: "enginehood",
        url: getStaticAssetPath(`img/icons/${brand}/animation-hood.svg`)
      },
      {
        id: "doors",
        url: getStaticAssetPath(`img/icons/${brand}/animation-doors.svg`)
      },
      {
        id: "windows",
        url: getStaticAssetPath(`img/icons/${brand}/animation-windows.svg`)
      },
      {
        id: "liftingsystem",
        url: getStaticAssetPath(`img/icons/${brand}/animation-liftingsystem.svg`)
      },
      {
        id: "trunk",
        url: getStaticAssetPath(`img/icons/${brand}/animation-trunk.svg`)
      },
      {
        id: "startbutton",
        url: getStaticAssetPath(`img/icons/${brand}/animation-start-button.svg`)
      }
    ];
  }

  return [
    {
      id: "doors",
      url: getStaticAssetPath(`img/icons/${brand}/animation-doors.svg`)
    },
    {
      id: "trunk",
      url: getStaticAssetPath(`img/icons/${brand}/animation-trunk.svg`)
    },
    {
      id: "roof",
      url: getStaticAssetPath(`img/icons/${brand}/animation-roof.svg`)
    }
  ];
}

export function getStaticImageAssetsOfAnimations(
  animations: string[],
  brand: Brand
): StaticImageAsset[] {
  const imageAssets = getAnimationImageAssetsSupportedByApp(brand);
  return filterStaticImageAssetsForIds(imageAssets, animations);
}
